import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../components/Modal";
import { Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { Button } from "../../../components/Button";
import { AlertIcon } from "../../../assets/icons";

const ModalCompleteLater = ({ showModal, handleCloseModal, isMobile, handleContinue }) => {
    
  return (
    <Modal
      open={showModal}
      onCancel={handleCloseModal}
      padding={!isMobile ? "29px 63px 37px 63px" : "29px 25px 37px 25px"}
      width={!isMobile ? "611px" : "100%"}
      height={"auto"}
    >
      <Modal.Header
        title={"¡Espera un momento!"}
        sizeTitle={theme.fonts.size.h1}
        colorTitle={theme.colors.blue500}
        weightTitle={theme.fonts.weight.bold}
        margin={"0 0 22px 0"}
        icon={<AlertIcon stroke={theme.colors.red} />}
        iconBackground={theme.colors.white50}
        iconBorderColor={theme.colors.red}
      />
      <Modal.Body>

        <Text
        size={theme.fonts.size.h6}
        color={theme.colors.gray200}
        weight={theme.fonts.weight.semibold}
        mb="20px"
        >
          ¿Quieres continuar después? Tus respuestas se guardarán y podrás completar la encuesta en cualquier momento. ¡Asegúrate de termínarla para participar en las dinámicas de Pulpey!
        </Text>

        <Button width={!isMobile ? "297px" : "230px"} onClick={handleContinue}>
          Continuar más tarde
        </Button>
      </Modal.Body>
    </Modal>
  );
};
ModalCompleteLater.propTypes = {
  showModal: PropTypes.bool,
  isMobile: PropTypes.isMobile,
  handleCloseModal: PropTypes.func,
};
export default ModalCompleteLater;
